import React, { Component } from 'react'
import Flight from 'react-flight/dom'
import PropTypes from 'prop-types'
import AppBar from './app-bar'

/*
-import { h } from 'preact'
-import React, { Children, Component } from 'preact-compat'
*/

class Line extends Component {
  triggerStart = () => {
    this.context.director.play()
  }
  render() {
    const { source, name, style } = this.props
    return (
      <div
        id={source && name}
        className={name}
        onClick={this.triggerStart}
        style={Object.assign({ borderRadius: 5 }, style)}
      />
    )
  }
}

Line.contextTypes = { director: PropTypes.object }

class App extends Component {
  render() {
    return (
      <Flight ref={flight=>this.flight = flight} interactive>
        <Flight.Frame duration={300}>
          <div>
            <AppBar />
            <div
              className="keyframe"
              style={{
                border: 'none',
                backgroundColor: '#F4F7F9',
                height: 280,
              }}
            >
              <Line
                name={'line1'}
                source={true}
                style={{
                  backgroundColor: '#E6ECF0',
                  left: 160,
                  top: 100 - 40,
                  width: 50,
                  height: 10,
                  borderRadius: 5,
                }}
              />

              <div
                id="line2"
                className="line2"
                style={{
                  backgroundColor: '#95A2AA',
                  left: 110,
                  top: 115 - 40,
                  width: 150,
                  height: 10,
                  borderRadius: 5,
                }}
              />

              <div
                id="line3"
                className="line3"
                style={{
                  backgroundColor: '#95A2AA',
                  left: 125,
                  top: 130 - 40,
                  width: 120,
                  height: 10,
                  borderRadius: 5,
                }}
              />

              <div
                id="circ1"
                className="circ1"
                style={{
                  backgroundColor: '#95A2AA',
                  left: 50,
                  top: 170 - 40,
                  width: 16,
                  height: 16,
                  borderRadius: 8,
                }}
              />
              <div
                id="line1-1"
                className="line1-1"
                style={{
                  backgroundColor: '#7ACC28',
                  left: 70,
                  top: 173 - 40,
                  width: 70,
                  height: 10,
                  borderRadius: 5,
                }}
              />
              <div
                id="line1-2"
                className="line1-2"
                style={{
                  backgroundColor: '#E6ECF0',
                  left: 70,
                  top: 188 - 40,
                  width: 80,
                  height: 10,
                  borderRadius: 5,
                }}
              />
              <div
                id="line1-3"
                className="line1-3"
                style={{
                  backgroundColor: '#E6ECF0',
                  left: 70,
                  top: 203 - 40,
                  width: 80,
                  height: 10,
                  borderRadius: 5,
                }}
              />

              <div
                id="circ2"
                className="circ2"
                style={{
                  backgroundColor: '#95A2AA',
                  left: 50,
                  top: 170 + 70 - 40,
                  width: 16,
                  height: 16,
                  borderRadius: 8,
                }}
              />
              <div
                id="line2-1"
                className="line2-1"
                style={{
                  backgroundColor: '#4DA1FF',
                  left: 70,
                  top: 173 + 70 - 40,
                  width: 70,
                  height: 10,
                  borderRadius: 5,
                }}
              />
              <div
                id="line2-2"
                className="line2-2"
                style={{
                  backgroundColor: '#E6ECF0',
                  left: 70,
                  top: 188 + 70 - 40,
                  width: 80,
                  height: 10,
                  borderRadius: 5,
                }}
              />
              <div
                id="line2-3"
                className="line2-3"
                style={{
                  backgroundColor: '#E6ECF0',
                  left: 70,
                  top: 203 + 70 - 40,
                  width: 80,
                  height: 10,
                  borderRadius: 5,
                }}
              />

              <div
                id="circ3"
                className="circ3"
                style={{
                  backgroundColor: '#95A2AA',
                  left: 50 + 180,
                  top: 170 - 40,
                  width: 16,
                  height: 16,
                  borderRadius: 8,
                }}
              />
              <div
                id="line3-1"
                className="line3-1"
                style={{
                  backgroundColor: '#FC6E4F',
                  left: 70 + 180,
                  top: 173 - 40,
                  width: 70,
                  height: 10,
                  borderRadius: 5,
                }}
              />
              <div
                id="line3-2"
                className="line3-2"
                style={{
                  backgroundColor: '#E6ECF0',
                  left: 70 + 180,
                  top: 188 - 40,
                  width: 80,
                  height: 10,
                  borderRadius: 5,
                }}
              />
              <div
                id="line3-3"
                className="line3-3"
                style={{
                  backgroundColor: '#E6ECF0',
                  left: 70 + 180,
                  top: 203 - 40,
                  width: 80,
                  height: 10,
                  borderRadius: 5,
                }}
              />

              <div
                id="circ4"
                className="circ4"
                style={{
                  backgroundColor: '#95A2AA',
                  left: 50 + 180,
                  top: 170 + 70 - 40,
                  width: 16,
                  height: 16,
                  borderRadius: 8,
                }}
              />
              <div
                id="line4-1"
                className="line4-1"
                style={{
                  backgroundColor: '#613F95',
                  left: 70 + 180,
                  top: 173 + 70 - 40,
                  width: 70,
                  height: 10,
                  borderRadius: 5,
                }}
              />
              <div
                id="line4-2"
                className="line4-2"
                style={{
                  backgroundColor: '#E6ECF0',
                  left: 70 + 180,
                  top: 188 + 70 - 40,
                  width: 80,
                  height: 10,
                  borderRadius: 5,
                }}
              />
              <div
                id="line4-3"
                className="line4-3"
                style={{
                  backgroundColor: '#E6ECF0',
                  left: 70 + 180,
                  top: 203 + 70 - 40,
                  width: 80,
                  height: 10,
                  borderRadius: 5,
                }}
              />
              <div
                id="brace-1"
                className="brace-1"
                style={{ color: '#95A2AA', top: 30, left: -50, fontSize: 30 }}
              >
                {'{'}
              </div>
              <div
                id="brace-2"
                className="brace-2"
                style={{ color: '#95A2AA', top: 180, left: -50, fontSize: 30 }}
              >
                {'}'}
              </div>
            </div>
          </div>
        </Flight.Frame>

        <Flight.Frame duration={300}>
          <div className="keyframe">
            <div
              className="line1"
              style={{
                backgroundColor: '#E6ECF0',
                left: -60,
                top: 100,
                width: 50,
                height: 10,
                borderRadius: 5,
              }}
            />

            <div
              className="line2"
              style={{
                backgroundColor: '#95A2AA',
                left: -160,
                top: 115,
                width: 150,
                height: 10,
                borderRadius: 5,
              }}
            />

            <div
              className="line3"
              style={{
                backgroundColor: '#95A2AA',
                left: -125,
                top: 130,
                width: 120,
                height: 10,
                borderRadius: 5,
              }}
            />

            <div
              className="circ1"
              style={{
                backgroundColor: '#95A2AA',
                left: -20,
                top: 170,
                width: 16,
                height: 16,
                borderRadius: 8,
              }}
            />
            <div
              className="line1-1"
              style={{
                backgroundColor: '#7ACC28',
                left: 70,
                top: 90,
                width: 70,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line1-2"
              style={{
                backgroundColor: '#E6ECF0',
                left: -90,
                top: 188,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line1-3"
              style={{
                backgroundColor: '#E6ECF0',
                left: -90,
                top: 203,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />

            <div
              className="circ2"
              style={{
                backgroundColor: '#95A2AA',
                left: -20,
                top: 170 + 70,
                width: 16,
                height: 16,
                borderRadius: 8,
              }}
            />
            <div
              className="line2-1"
              style={{
                backgroundColor: '#4DA1FF',
                left: 70,
                top: 110,
                width: 70,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line2-2"
              style={{
                backgroundColor: '#E6ECF0',
                left: 70,
                top: 170 + 188 + 70,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line2-3"
              style={{
                backgroundColor: '#E6ECF0',
                left: 70,
                top: 170 + 203 + 70,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />

            <div
              className="circ3"
              style={{
                backgroundColor: '#95A2AA',
                left: 50 + 180,
                top: 200 + 170,
                width: 16,
                height: 16,
                borderRadius: 8,
              }}
            />
            <div
              className="line3-1"
              style={{
                backgroundColor: '#FC6E4F',
                left: 70,
                top: 130,
                width: 70,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line3-2"
              style={{
                backgroundColor: '#E6ECF0',
                left: 150 + 70 + 180,
                top: 188,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line3-3"
              style={{
                backgroundColor: '#E6ECF0',
                left: 150 + 70 + 180,
                top: 203,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />

            <div
              className="circ4"
              style={{
                backgroundColor: '#95A2AA',
                left: 50 + 180,
                top: 200 + 170 + 70,
                width: 16,
                height: 16,
                borderRadius: 8,
              }}
            />
            <div
              className="line4-1"
              style={{
                backgroundColor: '#613F95',
                left: 70,
                top: 150,
                width: 70,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line4-2"
              style={{
                backgroundColor: '#E6ECF0',
                left: 150 + 70 + 180,
                top: 188 + 70,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line4-3"
              style={{
                backgroundColor: '#E6ECF0',
                left: 150 + 70 + 180,
                top: 203 + 70,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="brace-1"
              style={{ color: '#95A2AA', top: 30, left: 30, fontSize: 30 }}
            >
              {'{'}
            </div>
            <div
              className="brace-2"
              style={{ color: '#95A2AA', top: 180, left: 30, fontSize: 30 }}
            >
              {'}'}
            </div>
          </div>
        </Flight.Frame>

        <Flight.Frame duration={300}>
          <div className="keyframe">
            <div
              className="line1"
              style={{
                backgroundColor: '#E6ECF0',
                left: -60,
                top: 100,
                width: 50,
                height: 10,
                borderRadius: 5,
              }}
            />

            <div
              className="line2"
              style={{
                backgroundColor: '#95A2AA',
                left: -160,
                top: 115,
                width: 150,
                height: 10,
                borderRadius: 5,
              }}
            />

            <div
              className="line3"
              style={{
                backgroundColor: '#95A2AA',
                left: -125,
                top: 130,
                width: 120,
                height: 10,
                borderRadius: 5,
              }}
            />

            <div
              className="circ1"
              style={{
                backgroundColor: '#95A2AA',
                left: -20,
                top: 170,
                width: 16,
                height: 16,
                borderRadius: 8,
              }}
            />
            <div
              className="line1-1"
              style={{
                backgroundColor: '#7ACC28',
                left: 70,
                top: 90,
                width: 70,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line1-2"
              style={{
                backgroundColor: '#E6ECF0',
                left: -90,
                top: 188,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line1-3"
              style={{
                backgroundColor: '#E6ECF0',
                left: -90,
                top: 203,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />

            <div
              className="circ2"
              style={{
                backgroundColor: '#95A2AA',
                left: -20,
                top: 170 + 70,
                width: 16,
                height: 16,
                borderRadius: 8,
              }}
            />
            <div
              className="line2-1"
              style={{
                backgroundColor: '#4DA1FF',
                left: 70,
                top: 110,
                width: 70,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line2-2"
              style={{
                backgroundColor: '#E6ECF0',
                left: 70,
                top: 170 + 188 + 70,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line2-3"
              style={{
                backgroundColor: '#E6ECF0',
                left: 70,
                top: 170 + 203 + 70,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />

            <div
              className="circ3"
              style={{
                backgroundColor: '#95A2AA',
                left: 50 + 180,
                top: 200 + 170,
                width: 16,
                height: 16,
                borderRadius: 8,
              }}
            />
            <div
              className="line3-1"
              style={{
                backgroundColor: '#FC6E4F',
                left: 70,
                top: 130,
                width: 70,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line3-2"
              style={{
                backgroundColor: '#E6ECF0',
                left: 150 + 70 + 180,
                top: 188,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line3-3"
              style={{
                backgroundColor: '#E6ECF0',
                left: 150 + 70 + 180,
                top: 203,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />

            <div
              className="circ4"
              style={{
                backgroundColor: '#95A2AA',
                left: 50 + 180,
                top: 200 + 170 + 70,
                width: 16,
                height: 16,
                borderRadius: 8,
              }}
            />
            <div
              className="line4-1"
              style={{
                backgroundColor: '#613F95',
                left: 70,
                top: 150,
                width: 70,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line4-2"
              style={{
                backgroundColor: '#E6ECF0',
                left: 150 + 70 + 180,
                top: 188 + 70,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line4-3"
              style={{
                backgroundColor: '#E6ECF0',
                left: 150 + 70 + 180,
                top: 203 + 70,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="brace-1"
              style={{ color: '#95A2AA', top: 30, left: -30, fontSize: 30 }}
            >
              {'{'}
            </div>
            <div
              className="brace-2"
              style={{ color: '#95A2AA', top: 180, left: -30, fontSize: 30 }}
            >
              {'}'}
            </div>
          </div>
        </Flight.Frame>

        <Flight.Frame duration={300}>
          <div className="keyframe">
            <div
              className="line1"
              style={{
                backgroundColor: '#E6ECF0',
                left: -60,
                top: 100,
                width: 50,
                height: 10,
                borderRadius: 5,
              }}
            />

            <div
              className="line2"
              style={{
                backgroundColor: '#95A2AA',
                left: -160,
                top: 115,
                width: 150,
                height: 10,
                borderRadius: 5,
              }}
            />

            <div
              className="line3"
              style={{
                backgroundColor: '#95A2AA',
                left: -125,
                top: 130,
                width: 120,
                height: 10,
                borderRadius: 5,
              }}
            />

            <div
              className="circ1"
              style={{
                backgroundColor: '#95A2AA',
                left: -20,
                top: 170,
                width: 16,
                height: 16,
                borderRadius: 8,
              }}
            />
            <div
              className="line1-1"
              style={{
                backgroundColor: '#7ACC28',
                left: 90,
                top: 90,
                width: 70,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line1-2"
              style={{
                backgroundColor: '#E6ECF0',
                left: -90,
                top: 188,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line1-3"
              style={{
                backgroundColor: '#E6ECF0',
                left: -90,
                top: 203,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />

            <div
              className="circ2"
              style={{
                backgroundColor: '#95A2AA',
                left: -20,
                top: 170 + 70,
                width: 16,
                height: 16,
                borderRadius: 8,
              }}
            />
            <div
              className="line2-1"
              style={{
                backgroundColor: '#4DA1FF',
                left: 60,
                top: 110,
                width: 70,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line2-2"
              style={{
                backgroundColor: '#E6ECF0',
                left: 70,
                top: 170 + 188 + 70,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line2-3"
              style={{
                backgroundColor: '#E6ECF0',
                left: 70,
                top: 170 + 203 + 70,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />

            <div
              className="circ3"
              style={{
                backgroundColor: '#95A2AA',
                left: 50 + 180,
                top: 200 + 170,
                width: 16,
                height: 16,
                borderRadius: 8,
              }}
            />
            <div
              className="line3-1"
              style={{
                backgroundColor: '#FC6E4F',
                left: 70,
                top: 130,
                width: 70,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line3-2"
              style={{
                backgroundColor: '#E6ECF0',
                left: 150 + 70 + 180,
                top: 188,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line3-3"
              style={{
                backgroundColor: '#E6ECF0',
                left: 150 + 70 + 180,
                top: 203,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />

            <div
              className="circ4"
              style={{
                backgroundColor: '#95A2AA',
                left: 50 + 180,
                top: 200 + 170 + 70,
                width: 16,
                height: 16,
                borderRadius: 8,
              }}
            />
            <div
              className="line4-1"
              style={{
                backgroundColor: '#613F95',
                left: 110,
                top: 150,
                width: 70,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line4-2"
              style={{
                backgroundColor: '#E6ECF0',
                left: 150 + 70 + 180,
                top: 188 + 70,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="line4-3"
              style={{
                backgroundColor: '#E6ECF0',
                left: 150 + 70 + 180,
                top: 203 + 70,
                width: 80,
                height: 10,
                borderRadius: 5,
              }}
            />
            <div
              className="brace-1"
              style={{ color: '#95A2AA', top: 30, left: -30, fontSize: 30 }}
            >
              {'{'}
            </div>
            <div
              className="brace-2"
              style={{ color: '#95A2AA', top: 180, left: -30, fontSize: 30 }}
            >
              {'}'}
            </div>
          </div>
        </Flight.Frame>

      </Flight>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/anim1.js